/**
 * Page - Dashboard JS
 */

// CSS
import styles from '../scss/dashboard.scss';
import './spreadsheet-dataTables.js';
import './components/dashboard-walkthrough.js';
var $ = window.jQuery;

// This file has been imported already in /inc/wl-functions/assets.php line - 144
// import 'datatables.net-dt';

import 'waypoints/lib/jquery.waypoints.min';

$('html').on('click', '[data-stop-propagation]', (event) => {
  event.stopPropagation();
});

// Mobile dashboard menu
$('[data-toggle-dashboard-menu]').on('click', (event) => {
  $('html').toggleClass('html--dashboard-menu-open');
});
$('.has-submenu > span').on('click', (event) => {
  if (window.innerWidth < 1280) {
    const anchor = $(event.currentTarget)
      .next()
      .children('li:first-child')
      .children('a');
    window.open(anchor.attr('href'), anchor.attr('target') || '_self');
  }
});
$('.has-submenu').on('click', (event) => {
  if (window.innerWidth < 1280) {
    const target = event.currentTarget;
    if (target.classList.contains('expanded')) {
      target.classList.remove('expanded');
    } else {
      target.classList.add('expanded');
    }
  }
});

// Create waypoint for back to top button
$('.dashboard__content').waypoint(
  (direction) => {
    if (direction === 'down') {
      $('.sticky-utilities__top').removeClass('is-hidden');
    } else if (direction === 'up') {
      $('.sticky-utilities__top').addClass('is-hidden');
    }
  },
  { offset: 0 }
);

// Toggle content/excerpt
$('[data-show-content]').on('click', () => {
  $('[data-excerpt]').hide();
  $('[data-content]').show();
});

// Scanner DataTables
if ($('body').hasClass('page-template-dashboard-scanner-subpage')) {
  $('.scanner-load-content table').DataTable({
    pageLength: 100,
  });
}

// Scroll to top after using FacetWP search or pagination
$(document).on('facetwp-loaded', function () {
  if (FWP.loaded) {
    $('html, body').animate(
      {
        scrollTop: $('.facetwp-template').offset().top - 200,
      },
      500
    );
  }
});

function clean_url() {
  let url_arr = window.location.href.split('/');
  let index = url_arr.indexOf('page');
  if (index > 5) {
    url_arr.splice(index, 2);
    let URL = url_arr.join('/');
    window.history.pushState('lc_page', 'Learning Center', URL);
  }
}

// Simpler Central Learning Center Filters
$('#term_filter input:radio')
  .not($('.reset_filter input:radio'))
  .on('change', function () {
    var filter = $('#term_filter');
    filter.find('.apply_filter').trigger('click');
    $('#term_filter').find('.checked').not($(this)).removeClass('checked');
  });

$('.reset_filter input:radio').on('change', function () {
  $('#term_filter').find('.checked').removeClass('checked');
  var filter = $('#term_filter');
  filter.find('.apply_filter').trigger('click');
});

$('#term_filter').on('submit', function () {
  var filter = $('#term_filter');
  clean_url();
  $.ajax({
    url: filter.attr('action'),
    data: filter.serialize(), // form data
    type: filter.attr('method'), // POST
    beforeSend: function (xhr) {
      $('#response').html(
        `<div class="text-center"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>`
      );
    },
    success: function (data) {
      $('#response').html(data); // insert data
      $('h2.section-title').css('margin-bottom', '0!important');
    },
  });
  return false;
});

$('.free_trading_room').on('click', function (e) {
  e.preventDefault();
  let redirectUrl = $(this).attr('href');
  let slug = (url) => new URL(url).pathname.match(/[^\/]+/g);
  let userId = $(this).attr('data-user');
  const baseUrl = window.location.origin;
  const apiUrl = baseUrl + '/wp-json/free-trading-room/v1/assign';

  $.ajax({
    url: apiUrl,
    type: 'GET',
    dataType: 'json',
    data: {
      userId: userId,
    },
    success: function (res) {
      if (slug(redirectUrl)[0] === 'dashboard') {
        window.location.href = redirectUrl;
      }
    },
    error: function (XMLHttpRequest, textStatus, errorThrown) {
      console.error(textStatus);
      if (slug(redirectUrl)[0] === 'dashboard') {
        window.location.href = redirectUrl;
      }
    },
  });

  if (slug(redirectUrl)[0] !== 'dashboard') {
    window.open(redirectUrl, '_blank');
  }
});

window.onload = function () {
  $('.dash_main_links:not(:has(li))').parent().hide();
};
